import axios from "axios";
import PagedData from "../models/serviceModels/PagedData";

const baseUrl = process.env.REACT_APP_API_BASE_URL;

const encodeFilter = (filter: Record<string, unknown>): string => {
    const utf8Binary = encodeURIComponent(JSON.stringify(filter))
        .replace(/%([0-9A-F]{2})/g, (_, hex) => String.fromCharCode(Number.parseInt(hex, 16)));
    return btoa(utf8Binary);
};

const fetchSortableList = async <T>(
    entity: string,
    filter: Record<string, unknown>,
    skip: number,
    take: number,
    sortBy: string,
    sortDirection: 'asc' | 'desc'
): Promise<PagedData<T>> => {
    const result = await axios.get(`${baseUrl}/list`, {
        params: { entity, filter: encodeFilter(filter), skip, take, sortBy, sortDirection }
    });
    return result.data;
};

export { encodeFilter, fetchSortableList };
